import tokenData from '../../design-tokens/base-tokens.json';
const MuiChip = {
    defaultProps: {
        variant: 'outlined',
        size: 'small'
    },
    styleOverrides: {
        filled: {
            backgroundColor: tokenData.tokens.palette.darkBlue.darkBlue100,
            border: `0.5px solid ${tokenData.tokens.palette.blue.blue600}`,
            '& .MuiChip-label': {
                color: tokenData.tokens.palette.darkBlue.darkBlue700
            },
            '& .MuiChip-icon': {
                color: tokenData.tokens.palette.darkBlue.darkBlue700
            },
            '&:hover': {
                background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), linear-gradient(0deg, #E6EFF5, #E6EFF5)'
            },
            '&.Mui-focusVisible': {
                backgroundColor: tokenData.tokens.palette.darkBlue.darkBlue100
            }
        },
        sizeSmall: ({ theme }) => ({
            padding: theme.spacing(0, 3, 0, 3),
            '& .MuiChip-labelSmall': {
                padding: 0,
                ...theme.typography.body2
            },
            '& .MuiChip-icon': {
                marginLeft: '-2px',
                marginRight: '4px',
                ...theme.typography.body2
            },
            '& .MuiChip-deleteIcon': {
                fontSize: '16px',
                marginLeft: '6px',
                marginRight: '-2px',
                color: tokenData.tokens.palette.text.text100
            }
        }),
        sizeMedium: ({ theme }) => ({
            padding: theme.spacing(1.5, 2, 1.5, 4),
            '& .MuiChip-labelMedium': {
                padding: 0,
                ...theme.typography.body2
            },
            '& .MuiChip-icon': {
                marginLeft: '-2px',
                marginRight: '4px',
                fontSize: '16px'
            },
            '& .MuiChip-deleteIcon': {
                fontSize: '16px',
                marginLeft: '8px',
                marginRight: '-1px',
                color: tokenData.tokens.palette.text.text100
            }
        }),
        root: {
            height: 'unset',
            padding: 0,
            borderColor: tokenData.tokens.palette.grey.grey300,
            '&.Mui-focusVisible': {
                outlineOffset: '1px',
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.text.text300,
                '&:not(.MuiChip-filled)': {
                    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), #FFFFFF'
                }
            },
            '&.MuiChip-clickable': {
                '&:not(.MuiChip-filled):hover': {
                    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)), #FFFFFF'
                }
            }
        }
    }
};
export default MuiChip;
